/**
 * Fixed width (px) every widget in the bottom-right stack is drawn at.
 *
 * The stack aligns its children to the right edge rather than
 * stretching them, so this is also the width the stack itself needs
 * wherever it lands.
 */
export const GLOBAL_SNACKBAR_WIDGET_WIDTH_PX = 340;

/**
 * Gap (px) the stack keeps between its widgets, and between itself
 * and a neighbour it has lifted above.
 *
 * Mirrors the `theme.new.spacing.medium` token the stack's own styles
 * apply, and has to stay in step with it: anything sizing a viewport
 * against the stack needs this as a number rather than a token.
 */
export const GLOBAL_SNACKBAR_STACK_GAP_PX = 16;

/**
 * Gap (px) the stack keeps from the viewport's right edge, and from a
 * neighbour it has stepped left of.
 *
 * Mirrors `theme.new.spacing.large` in the stack's own styles, for the
 * same reason as {@link GLOBAL_SNACKBAR_STACK_GAP_PX}.
 */
export const GLOBAL_SNACKBAR_STACK_EDGE_OFFSET_PX = 24;
